// @flow

import { makeStyles } from '@material-ui/styles';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Icon, IconInviteMore } from '../../../base/icons';
import ParticipantsPaneButton from '../../../participants-pane/components/web/ParticipantsPaneButton';
import { setShowRtaJamInvitePopup } from '../../redux/tool-webjam-v3/actions';
import { getBaseConfig } from '../../Utils';
import Button from '../../../base/ui/components/web/Button';
import { BUTTON_TYPES } from '../../../base/ui/constants.any';
import { close as closeParticipantsPane } from '../../../participants-pane/actions.any';
import { ct } from '../../constant-Utils';

const useStyles = makeStyles(theme => {
    return {
        button: {
            width: '100%',

            // '& > *:not(:last-child)': {
            //     marginRight: `${theme.spacing(2)}px`
            // }
        }
    };
});

export const InviteJamPartnerButton = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const styles = useStyles();
    const socialWebLogoWhite = getBaseConfig("socialWebLogoWhite");
    const onInvite = useCallback(() => {
        dispatch(setShowRtaJamInvitePopup(true));
        dispatch(closeParticipantsPane());
    }, [dispatch]);
    //CUSTOM
    return (
        <Button
            d_type={"tab-button"}
            accessibilityLabel={t('participantsPane.actions.invite')}
            className={styles.button + ' find-jam-partner'}
            fullWidth={true}
            image={socialWebLogoWhite}
            imageHeight={"16px"}
            imageWidth={"18px"}
            d_type="tab-button" // CUSTOM
            label={ct("rta-trmc.rtaInviteModal.findAJamPartner")}
            onClick={onInvite}
            type={BUTTON_TYPES.PRIMARY}
        >
        </ Button>
    );
};
